import { Component, OnInit, Input } from "@angular/core";
import { Label } from "ng2-charts";
import { ChartDataSets, ChartOptions, ChartScales, ChartType } from "chart.js";

@Component({
  selector: 'app-stacked-bars-for-home',
  templateUrl: './stacked-bars-for-home.component.html',
  styleUrls: ['./stacked-bars-for-home.component.scss']
})
export class StackedBarsForHomeComponent implements OnInit {

  @Input() barra1: number;
  @Input() trainingOrPolicie: number;
  @Input() color: string;
  public barChartData :ChartDataSets[];
  public barChartOptions: ChartOptions = {
    responsive: true,

    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: true,
      mode: "y",
      titleFontColor: "transparent",
      titleMarginBottom: 0,
      titleFontSize: 10,
      callbacks: {
        label: (tooltipItem, chart) => {
          const realValue =
            chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          const customValue = realValue + "%";
          const label = chart.datasets[tooltipItem.datasetIndex].label
          return `${label}`+": "+ customValue;
        },
      },
      
    },
    scales:{
      xAxes: [
       { ticks: {
          stepSize: 25,
          callback: function (value) {
            return value + '%';
          },
      }}
      ]
     
  }
}

  public barChartType: ChartType = "horizontalBar";
  public barChartLegend = false;
  public display: ChartScales = { display: false };

  public barChartLabels: Label[] = ["Concluídos"];
  public chartColors: Array<any> = [];
 
  
  result: number;

  ngOnInit() {
    this.customizeChartBar();
  }
  customizeChartBar() {
    if(this.trainingOrPolicie == 1){
      this.barChartData = [
        {
          data: [],
          label: "Aceites",
          stack: "A",
    
          showLine: false,
        },
        {
          data: [],
          label: "Não aceites",
          stack: "A",
    
          showLine: false,
        },
      ];
     
    }
    if(this.trainingOrPolicie == 2){
      this.barChartData = [
        {
          data: [],
          label: "Concluídos",
          stack: "A",
    
          showLine: false,
        },
        {
          data: [],
          label: "À começar",
          stack: "A",
          showLine: false,
        },
      ];
     
    }
    let objColor = {
      backgroundColor: this.color,
    };
    let objColor2 = {
      backgroundColor: "transparent",
    };

    this.chartColors.push(objColor)
    this.chartColors.push(objColor2)
    if(this.barra1 >= 100){
      this.barChartData[0].data.push(this.barra1);
      this.barChartData[1].data.push(0);
    }else {
      this.barChartData[0].data.push(this.barra1);
      this.barChartData[1].data.push(100 - this.barra1);
    }
    
  }
}
